
export default class ViewTemplate {

    public id             : ID
    public name           : string
    public viewSystemType : any
    public access         : string // private | ?
    public userId         : ID | false
    public isDefault      : boolean
    public appSettings    : any

    constructor(config:any) {
        this.id             = _.get(config,'id')
        this.name           = _.get(config,'name')
        this.viewSystemType = _.get(config,'viewSystemType')
        this.access         = _.get(config,'access','private')
        this.userId         = _.get(config,'userId', false)
        this.isDefault      = _.get(config,'isDefault', false)
        this.appSettings    = _.get(config,'appSettings')

        this.normalize();
    }

    normalize() {
        if (!this.appSettings) this.appSettings = {};
    }

    toJSON() {
        const result : any = {
            id             : this.id,
            name           : this.name,
            viewSystemType : this.viewSystemType,
            access         : this.access,
            appSettings    : this.appSettings,
            userId         : this.userId,
        }

        if (this.isDefault) result.isDefault = true

        return result
    }


}